<div fxLayout="row" style="width: 100%; height: 100%">
	<div fxLayout="column" fxFlex>
		<nx-ahs-vanilla-json-editor
			#jsoneditor
			fxFlex
			[content]="content"
			[subtractHeight]="185"
			(jsonChanged)="jsonHasChanged($event)"
			(onSelect)="editorOnSelect($event)"
		></nx-ahs-vanilla-json-editor>
	</div>
</div>
